module.exports = __webpack_public_path__ + "img/digit-3.d5d42261.png";